import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './Checkbox.module.scss.js';
import FormField, { FormFieldPropTypes, FormFieldInputPropTypes } from '../FormField/index.js';

var _excluded = ["disabled", "indeterminated", "text", "className", "label", "input", "meta", "required", "customTitleClass", "description", "customDescriptionClass", "customContentClass", "icon", "outerClassName", "innerClassName", "style", "fieldProps", "textColor"];
var Checkbox = function Checkbox(props) {
  var _classNames, _classNames2, _classNames3, _classNames4;
  var disabled = props.disabled,
    indeterminated = props.indeterminated,
    text = props.text,
    className = props.className,
    label = props.label,
    input = props.input,
    meta = props.meta,
    required = props.required,
    customTitleClass = props.customTitleClass,
    description = props.description,
    customDescriptionClass = props.customDescriptionClass,
    customContentClass = props.customContentClass,
    icon = props.icon,
    outerClassName = props.outerClassName,
    innerClassName = props.innerClassName,
    _props$style = props.style,
    _props$style2 = _props$style === void 0 ? {} : _props$style,
    _props$style2$checkMa = _props$style2.checkMarkInner,
    checkMarkInner = _props$style2$checkMa === void 0 ? {} : _props$style2$checkMa,
    fieldProps = props.fieldProps,
    textColor = props.textColor,
    args = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React.createElement(FormField, _extends({
    label: label,
    required: required,
    meta: meta,
    className: className,
    input: input
  }, fieldProps), /*#__PURE__*/React.createElement("div", _extends({
    className: cx(styles.checkbox, (_classNames = {}, _classNames[styles.disabled] = disabled, _classNames))
  }, args), /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    className: styles.input
  }, input)), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.content, (_classNames2 = {}, _classNames2[styles.disabled] = disabled, _classNames2), customContentClass)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.checkMark
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.checkMarkOuter, (_classNames3 = {}, _classNames3[styles.selected] = input.checked || indeterminated, _classNames3), outerClassName)
  }), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.checkMarkInner, (_classNames4 = {}, _classNames4[styles.selected] = input.checked || indeterminated, _classNames4[innerClassName] = input.checked, _classNames4)),
    style: input.checked ? checkMarkInner.checked : checkMarkInner.default
  }, input.checked ? /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "white" // $form-check-input-checked-color
    ,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M4 8.5L6.5 11l6-6"
  })) : indeterminated ? /*#__PURE__*/React.createElement("span", {
    className: cx(styles.indeterminate, styles.checkIcon)
  }) : null)), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.checkBoxText, customTitleClass)
  }, icon && icon, /*#__PURE__*/React.createElement("label", {
    className: cx(styles.title),
    style: textColor ? {
      color: textColor
    } : {}
  }, text)), description && /*#__PURE__*/React.createElement("div", {
    className: cx(styles.checkBoxText, customDescriptionClass)
  }, /*#__PURE__*/React.createElement("label", {
    className: cx(styles.description)
  }, description)))));
};
Checkbox.defaultProps = {
  disabled: false,
  indeterminated: false,
  innerClassName: '',
  text: ''
};
Checkbox.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  customContentClass: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  customDescriptionClass: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  customTitleClass: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  description: PropTypes.node,
  disabled: PropTypes.bool,
  fieldProps: PropTypes.shape(FormFieldPropTypes),
  input: PropTypes.shape(FormFieldInputPropTypes),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]),
  indeterminated: PropTypes.bool,
  innerClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** This will be deprecated eventually. Instead pass a label to the fieldProps */
  label: PropTypes.node,
  meta: PropTypes.object.isRequired,
  name: PropTypes.string,
  outerClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  required: PropTypes.bool,
  style: PropTypes.object,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func, PropTypes.node]),
  textColor: PropTypes.string
};

export { Checkbox as default };
//# sourceMappingURL=index.js.map
